import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm2-16H3v18h18V3z"
}), 'InsertChartOutlinedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertChartOutlinedSharp.js
// module id = 4259
// module chunks = 2